import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2129db64"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "manifesto-buttons" }, null, -1))
const _hoisted_2 = { class: "manifesto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 data-v-2129db64> EthPrague 2022 is now over. We hope you enjoyed! </h1><div class=\"manifesto__buttons\" data-v-2129db64><div class=\"manifesto__buttons-row\" data-v-2129db64><a href=\"https://www.youtube.com/playlist?list=PLkCRcxMT8qhZ7BJXscrgRS3bBUtjrfu8x\" target=\"_blank\" class=\"manifesto__button-link\" data-v-2129db64><button class=\"manifesto__button\" data-v-2129db64> See the talks <span class=\"manifesto__headless-arrow\" data-v-2129db64></span></button></a></div><div class=\"manifesto__buttons-row\" data-v-2129db64><a href=\"https://ethprague-2022.devpost.com/project-gallery\" target=\"_blank\" class=\"manifesto__button-link\" data-v-2129db64><button class=\"manifesto__button\" data-v-2129db64>Project Gallery<span class=\"manifesto__headless-arrow\" data-v-2129db64></span></button></a></div></div>", 2)
const _hoisted_5 = {
  id: "Manifesto",
  class: "manifesto__text-container"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "manifesto__text-content" }, " ETHPrague isn’t looking for the next get rich quickly scheme or groundbreaking DeFi apps, instead it’s an event focusing on the future potential of Ethereum and concepts or applications which don’t yet exist. We want to tackle challenges which will or might arise in the next decade and we believe Ethereum will play a major role in solving these. The future is in your hands, anon! You decide whether we end up living in a dark authoritarian dystopia or a bright solarpunk utopia. ", -1))

import SectionTitle from "@/components/SectionTitle.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'Manifesto',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(SectionTitle, { title: "manifesto" }),
        _hoisted_6
      ])
    ])
  ], 64))
}
}

})